import { Log } from '@/types/logs'

export const checkBulkCurtailmentValues = (log: Log): boolean =>
    !!log.bulkCurtailment?.runTo || !!log.bulkCurtailment?.dutyTo || !!log.bulkCurtailment?.fleetTo
